export interface BankAccountInfo {
  title: string;
  beneficiaryName: string;
  format: server.dto.BankAccountFormat;
  abaRoutingNumber: string;
  accountNumber: string;
  bsbCode: string;
  iban: string;
  swiftCode: string;
  sortCode: string;
  bankAddress: string;
  branchName: string;
  branchCode: string;
  institutionNumber: string;
  transitNumber: string;
  memo: string;
}

export interface BankAccountNewInfo extends BankAccountInfo {
  bookkeepings: server.dto.BookkeepingSmall[];
}

export const getValueIfVisibleOrDefault = (value: string, visible: boolean) => {
  return visible ? value : "";
};